$(document).ready(function() {
  $('[data-bs-toggle="tooltip"]').tooltip();

  $(".js-position").each(function (index) {
    $(this).val(index);
  });


  function validatePriceInput(value) {
    return /^[-ー−]?[0-9０-９]{0,8}(([.．。][0-9０-９]{0,2})?)$/.test(value.replace(/,/g,''));
  }

 
  function applyPriceValidation() {
    $("#form-template-items .js-price").inputFilterx(
      validatePriceInput,
      "整数部分は最大8桁、小数部分は最大2桁です。負の値も入力できます。"
    );
  }

  // Apply validation on page load
  applyPriceValidation();

  $(document).on("change", ".level-select", function() {
    let $row = $(this).closest(".nested-fields");

    if ($(this).val() !== '') {
      $row.find(".product-label").removeClass("hidden").show();
      $row.find(".execution_template_execution_template_items_product_id").addClass("hidden");
      $row.find(".js-product-id, .input-field").val('');
      $row.find('.input-field').prop('disabled', true);
    } else {
      $row.find(".product-label").addClass("hidden");
      $row.find(".execution_template_execution_template_items_product_id").removeClass("hidden");
      $row.find('.input-field').prop('disabled', false);
    }
    updatePadding($row)
  });

  $(document).on('change', '.js-product-id', function(){
    $row = $(this).closest('.nested-fields');
    updatePadding($row)
  });

  $(".level-select").trigger("change");

  function updatePadding($row) {
    let level = parseInt($row.find(".level-select").val(), 10);
    let $productLabel = $row.find('.product-label');
    let $productIdFromGroup = $row.find('.execution_template_execution_template_items_product_id');
    let $parentFiled = $row.find('.parent-fields')
    if (level === 1) {
      $productLabel.css("text-indent", "0px");
      $parentFiled.css('background-color', '#608ED7');
    }
    else if (level === 2) {
      $productLabel.css("text-indent", "10px");
      $parentFiled.css('background-color', '#A1D1EE');
    } else if (level === 3) {
      $productLabel.css("text-indent", "20px");
      $parentFiled.css('background-color', '#D2E5F9');
    } else {
      $parentFiled.css('background-color', '#fff');
      let $parentRow = $row.prevAll(".nested-fields").filter(function () {
        let parentLevel = parseInt($(this).find(".level-select").val(), 10);
        return !isNaN(parentLevel);
      }).first();

      if ($parentRow.length) {
        let parentPadding = parseInt($parentRow.find(".product-label").css("text-indent"), 10);
        $productIdFromGroup.css("text-indent", (parentPadding + 10) + "px");
      } else {
        $productIdFromGroup.css("text-indent", "0px");
      }
    }
  }

  $(document).on("click", ".js-btn-add-item-top", function () {
    setTimeout(function () {
      $(".nested-fields").each(function (index) {
        $(this).find(".js-position").val(index);
      });
      applyPriceValidation();
    }, 100);
    toggleDiscountFields();
  });

  $(document).on("click", ".js-btn-add-item-bottom", function () {
    setTimeout(function () {

      let lastPosition = Math.max(...$(".js-position").map(function () {
        return parseInt($(this).val()) || 0;
      }).get());

      $(".nested-fields").last().find(".js-position").val(lastPosition + 1);

      applyPriceValidation();
    }, 100);
    toggleDiscountFields();

  });

  $(document).on("click", ".btn-add-item-mid", function () {
    let currentTime = Date.now();
    let $currentRow = $(this).closest(".nested-fields");
    $currentRow.find(".select2.js-product-id").select2("destroy");

    let $newRow = $currentRow.clone(true);

    $newRow.find(".input-field").prop("disabled", false);
    $newRow.find(".input-field, .product-label").val('');
    $newRow.find('.level-select').val('');
    $newRow.find(".parent-fields").css('background-color', '');
    $newRow.find(".execution_template_execution_template_items_product_id").removeClass("hidden");
    $newRow.find(".product-label").addClass("hidden");
    $newRow.find('.sell-price').val('');
    $newRow.find('.sell-price').css('background-color', '');
    $newRow.find(".select2.js-product-id").each(function () {
      $(this).removeAttr("data-select2-id");
      $(this).removeAttr("aria-hidden");
      let newId = $(this).attr("id") + "_" + currentTime;
      $(this).attr("id", newId);
    });
    $newRow.find(".select2.js-product-id").val('').trigger("change");
    $newRow.find("input, select").each(function () {
      let timestamp = currentTime;
      let name = $(this).attr("name");
                  if (name) {
          name = name.replace(/\[execution_template_items_attributes\]\[\d+\]/, "[execution_template_items_attributes][" + timestamp + "]");
          $(this).attr("name", name);
      }
  });

    $currentRow.after($newRow);

    $(".nested-fields").each(function (index) {

      $(this).find(".js-position").val(index);
    });
    $(".select2.js-product-id").select2({theme: "bootstrap", placeholder: "選択してください"});

    applyPriceValidation();
  });

  function toggleDiscountFields() {
    let hasLevel = $('.nested-fields:visible .level-select').filter(function() {
        return $(this).val() !== '';
    }).length > 0;
    $('.discount').prop('disabled', hasLevel);
    $('.execution-sell-price').css('background-color', hasLevel ? '#e9ecef' : '');
  }

});
